







































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LinearLoader extends Vue {
  /**
   * A boolean value to indicate whether the loaded is active
   */
  @Prop({ required: true, type: Boolean })
  private active!: boolean;
}
